import { render, staticRenderFns } from "./tipsAlert.vue?vue&type=template&id=e9552a2e&scoped=true&"
import script from "./tipsAlert.vue?vue&type=script&lang=js&"
export * from "./tipsAlert.vue?vue&type=script&lang=js&"
import style0 from "./tipsAlert.vue?vue&type=style&index=0&id=e9552a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9552a2e",
  null
  
)

export default component.exports